import { OneDeletePostDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useDeletePostActionResolver: OneCreationActionResolver = () => {
  const [deletePost, { loading }] = useMutation(OneDeletePostDocument, {
    extractorFn: (data) => data.postsMutations.deletePostsPost,
    errorPolicy: 'all',
  })

  const deletePostHandler = async (args: { id: string }) => {
    const result = await deletePost({
      variables: {
        id: args.id,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: deletePostHandler,
    loading,
  }
}

export const DeletePostAction: OneCreateAction = {
  actionResolver: useDeletePostActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
